import { useUpdateValueMeta, useValueWithAxis } from '@/hooks/useClassification'
import { MetaJsonEditor } from './MetaJsonEditor'

/**
 * The AXIS VALUE's `meta`, as opposed to the catalog row's.
 *
 * A brand or product is two records: the catalog row people edit, and the axis value the
 * taxonomy classifies against. Each has its own `meta`, and the Meta tab reads both — so
 * showing only the first in the editor left half of what a reader can see uncorrectable.
 * This is where `veeva_matched`, `veeva_object_type` and the load's own bookkeeping live.
 *
 * Resolves its own axis from the value id, because the page carries the value's meta but
 * not the axis it belongs to.
 */
export function TaxonomyMetaEditor({
	valueId,
	meta,
	subject,
}: {
	valueId: string
	meta: Record<string, unknown>
	subject: 'brand' | 'product'
}) {
	const resolved = useValueWithAxis(valueId)
	const axisId = resolved?.axis?.axisId ?? ''
	const update = useUpdateValueMeta(axisId, valueId)

	return (
		<MetaJsonEditor
			meta={meta}
			subject={subject}
			title="Raw meta — taxonomy value"
			description="What the classification value stores: its Veeva provenance and the load's own bookkeeping."
			saving={update.isPending}
			onSave={(next) => update.mutate(next)}
		/>
	)
}
